import { render, staticRenderFns } from "./DocumentTitle.vue?vue&type=template&id=42afa56f&"
import script from "./DocumentTitle.vue?vue&type=script&lang=js&"
export * from "./DocumentTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports